<template lang="pug">
	.editor-control-input-number-drag(:style="{zIndex: dragProcess ? 2000 : 2}" :class="{'change-process': changedValue !== null, [theme]: true, disabled: disabled === true}")
		.cursor-container(v-if="dragProcess" :style="{cursor: ({'fa-arrows-h': 'ew-resize', 'fa-arrows-w': 'ns-resize'})[options.controlOptions?.icon]}")
		.input-title(v-if="title" :style="{width: (options.titleWidth || '') + 'px'}") {{title}}
		.control-number(v-on:wheel="processChangeValueByMouseWheel($event)")
			.number-input
				label
					input.form-control(:value="getDisplayedValue()" :style="{width: options.controlOptions?.inputWidth ? `${options.controlOptions?.inputWidth}px` : undefined}" v-on:keydown="startChangeValueByKeyPress($event)" v-on:change="changeValueByInput($event.target.value, $event, false)" v-on:focus="blockUpdate()" v-on:blur="unblockUpdate($event.target.value)" :disabled="disabled === true")
			.control-point-drag(v-if="options.controlOptions?.drag || null" :class="{active: dragProcess || changedValue !== null}" v-on:mousedown="startDrag($event)")
				.fa(:class="options.controlOptions?.icon")
</template>

<script>

	import Screen 							from './../../../mixins/screen'

	import { Creative }						from './../../../services/Creative'
	import { Elements }						from './../../../services/Elements'

	export default {
		name: 'InputNumberDrag',
		mixins: [Screen],
		screen: {
			updateOn: [
				"Selected Version Switched",
				"Selected Screen Switched",
				"Selected Element Switched"
			],
			events: {
				"Selected Element Changed": function() {

					this.update();

				}
			}
		},
		components: {},
		props: ["title", "default", "value", "disabled", "disabledValue", "options", "theme"],
		data() {

			this.element = null;

			this.dragProcess = null;
			this.keyPressProcess = null;

			return {
				showed: true,
				changedValue: null
			};

		},
		mounted() {

			window.addEventListener("mouseup", () => {

				if (this.dragProcess) this.stopDrag();

			});

			window.addEventListener("mousemove", e => {

				if (this.dragProcess) this.processDrag(e);

			});

			window.addEventListener("keydown", e => {

				if (e.keyCode === 16) {

					if (this.keyPressProcess) this.keyPressProcess.shiftKey = true;
					if (this.dragProcess) this.dragProcess.shiftKey = true;

					this.update();

				}

				if (e.keyCode === 17) {

					if (this.keyPressProcess) this.keyPressProcess.ctrlKey = true;
					if (this.dragProcess) this.dragProcess.ctrlKey = true;

					this.update();

				}

			});

			window.addEventListener("keyup", e => {

				if (this.keyPressProcess && (e.keyCode === 38 || e.keyCode === 40)) this.stopChangeValueByKeyPress();

				if (e.keyCode === 16) {

					if (this.keyPressProcess) this.keyPressProcess.shiftKey = false;
					if (this.dragProcess) this.dragProcess.shiftKey = false;

					this.update();

				}

				if (e.keyCode === 17) {

					if (this.keyPressProcess) this.keyPressProcess.ctrlKey = false;
					if (this.dragProcess) this.dragProcess.ctrlKey = false;

					this.update();

				}

			});

		},
		methods: {
			collectData() {

				this.element = Elements.SelectedElement;

				// console.log('collectData', this.default, this.value, this.options);

			},
			getDisplayedValue() {

				if (this.disabled && this.disabledValue) return this.disabledValue;

				let value = this.changedValue !== null ? this.changedValue : this.value;

				if (value === undefined || value === null) value = this.default;

				if (this.options.controlOptions?.percent) value = `${parseInt(value * 100)}%`;
				else if (this.options.changes && "accuracy" in this.options.changes) value = parseInt(value * Math.pow(10, this.options.changes.accuracy)) / Math.pow(10, this.options.changes.accuracy);

				return value;

			},
			getValue() {

				let value = null;

				if (this.changedValue !== null) value = this.changedValue;
				else if (this.value !== undefined) value = this.value;
				else value = this.default;

				value = this.restoreValueType(value);

				return value;

			},
			setValue(value, fixAccuracy = true, forceUpdate = false) {

				if (this.options.changes && "max" in this.options.changes)
					if (value > this.options.changes.max) value = this.options.changes.max;

				if (this.options.changes && "min" in this.options.changes)
					if (value < this.options.changes.min) value = this.options.changes.min;

				if (fixAccuracy && this.options.changes && "accuracy" in this.options.changes) this.changedValue = value.toFixed(this.options.changes.accuracy);
				else this.changedValue = value;

				if (forceUpdate) this.$forceUpdate();
				else this.update();

				this.sendValue(this.getValue());

			},
			restoreValueType(value) {

				return parseFloat(value);

			},
			sendValue(value) {

				this.$emit('input', value);

				clearTimeout(this.sendTimeout);
				this.sendTimeout = setTimeout(() => {

					this.$emit('change', value);

					clearTimeout(this.sendTimeout);
					this.sendTimeout = setTimeout(() => {

						this.changedValue = null;

						this.update();

					}, 200);

				}, 500);

			},
			isDisplayedValueChanged() {

				if (this.changedValue === null) return false;

				let changedValue = this.restoreValueType(this.changedValue),
					baseValue = this.restoreValueType(this.value);

				return JSON.stringify(changedValue) !== JSON.stringify(baseValue);

			},
			getChangeProcess() {

				return this.dragProcess;

			},
			changeValueByInput(value, e = null, isSave = true) {

				if (!e || (e.keyCode !== 38 && e.keyCode !== 40)) {

					if (this.changedValue === null) this.changedValue = (this.value !== undefined && this.value !== null) ? _.cloneDeep(this.value) : _.cloneDeep(this.default);

					value = parseFloat(value);

					if (this.options.controlOptions?.percent) value = value / 100;

					if (_.isNaN(value)) value = undefined;

					if (value !== undefined) {

						this.changedValue = value;

						if (isSave) this.setValue(this.changedValue, false);

					}

				}

			},
			startChangeValueByKeyPress(e) {

				if (e.keyCode === 38 || e.keyCode === 40) {

					if (!this.keyPressProcess) {

						this.keyPressProcess = {
							increaser: e.keyCode === 40 ? -1 : 1,
							shiftKey: e.shiftKey
						};

						this.keyPressProcess.timeout = setTimeout(() => {

							this.changeValue(this.keyPressProcess.increaser, this.keyPressProcess.shiftKey, true);

							this.keyPressProcess.interval = setInterval(() => {

								this.changeValue(this.keyPressProcess.increaser, this.keyPressProcess.shiftKey, true);

							}, 50);

						}, 200);

						this.changeValue(this.keyPressProcess.increaser, this.keyPressProcess.shiftKey, true);

					}

					e.preventDefault();

				}

			},
			stopChangeValueByKeyPress() {

				if (this.keyPressProcess) {

					clearTimeout(this.keyPressProcess.timeout);
					clearInterval(this.keyPressProcess.interval);
					clearTimeout(this.keyPressProcess.stopTimeout);

					this.keyPressProcess = null;

				}

			},
			processChangeValueByMouseWheel(e) {

				this.changeValue(Math.sign(e.wheelDelta), e.shiftKey, true);

			},
			startDrag(e) {

				this.dragProcess = {
					active: false,
					messages: this.options.messages,
					downValue: this.getValue(),
					downPointerPosition: {
						x: e.clientX,
						y: e.clientY
					}
				};

				this.update();

				this.$emit('startDragProcess', this.dragProcess);

			},
			processDrag(e) {

				if (this.dragProcess.active) {

					let offsetX = (e.clientX - this.dragProcess.downPointerPosition.x),
						offsetY = (e.clientY - this.dragProcess.downPointerPosition.y);

					let offset = this.options.controlOptions?.icon === "fa-arrows-v" ? -offsetY : offsetX; // Как минимум все настройки анимации требуют тут -offsetY а не offsetY

					// Делаем так, чтобы смещение на 5 пикселей смещало значение на один шаг
					if (this.options.changes?.step) {

						let pixelWeight = this.options.changes?.step / 10;

						offset = offset * pixelWeight;

					}

					let newValue = this.normalizeValue(this.dragProcess.downValue + offset);

					this.setValue(newValue);

					this.update();

				} else {

					let dx = e.clientX - this.dragProcess.downPointerPosition.x,
						dy = e.clientY - this.dragProcess.downPointerPosition.y;

					this.dragProcess.active = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2)) > 3;

				}

			},
			stopDrag() {

				this.dragProcess = null;

				this.update();

				this.$emit('stopDragProcess');

			},
			changeValue(increaser, shiftKey, forceUpdate = false) {

				if (this.changedValue === null) this.changedValue = (this.value !== undefined && this.value !== null) ? _.cloneDeep(this.value) : _.cloneDeep(this.default);

				let newValue = parseFloat(this.changedValue);

				newValue += (this.options.changes?.step || 1) * increaser * (shiftKey ? 10 : 1);

				this.setValue(newValue, false, forceUpdate);

			},
			normalizeValue(value) {

				if (this.dragProcess?.shiftKey && this.dragProcess?.ctrlKey) {

					value = Math.round(value / 5) * 5;

				} else if (this.dragProcess?.shiftKey) {

					value = Math.round(value / 50) * 50;

				} else if (this.dragProcess?.ctrlKey) {

					value = Math.round(value / 20) * 20;

				}

				return value;

			},
			blockUpdate() {

				// Запрещаем апдейт компонента пока фокус стоит в поле ввода информации
				this.updateBlocked = true;

				console.log('blockUpdate');

			},
			unblockUpdate(value) {

				this.changeValueByInput(value);

				this.updateBlocked = false;

				// Пробуем через таймаут обновить компонент
				// Если updateBlocked к этому моменту всё ещё будет false то компонент обновится и отобразит новые клиентские данные
				// Это делается чтобы заблокировать обновление полей ввода пока пользователь не завершил их ввод
				// Без этого автообновления мешают печатать новые значения в полях типа coords
				clearTimeout(this.updateTimeout);
				this.updateTimeout = setTimeout(() => {

					this.update();

				}, 200);

				console.log('unblockUpdate');

			}
		}

	}
</script>

<style lang="sass">

	.editor-control-input-number-drag
		color: #f3f4f5
		display: flex
		flex-direction: row
		flex-wrap: nowrap
		min-height: 31px
		align-items: center

		.cursor-container
			position: fixed
			z-index: 2
			left: 0
			top: 0
			width: 100%
			height: 100%
			cursor: move

		.input-title
			display: flex
			justify-content: left
			overflow: hidden
			text-overflow: ellipsis
			color: var(--secondary)
			font-size: 0.85rem
			padding-right: 0.5rem
			cursor: default
			user-select: none

		.control-number
			display: flex
			flex-direction: row
			flex-wrap: nowrap
			align-items: center
			justify-content: left

			.number-input
				display: flex
				flex-direction: row
				flex-wrap: nowrap
				color: rgba(255, 255, 255, 0.87)
				transition: border-color 0.35s ease-in-out, box-shadow 0.35s ease-in-out, color 0.35s ease-in-out
				width: 80px

				label
					display: flex
					flex-direction: row
					flex-wrap: nowrap
					margin: 0
					padding: 0

			.control-point-drag
				display: flex
				justify-content: center
				align-items: center
				width: 29px
				height: 29px
				border: 1px solid rgba(255, 255, 255, 0.09)
				background-color: rgba(255, 255, 255, 0.05)
				border-radius: 0.1rem
				cursor: pointer
				margin-left: 5px
				color: #73818f
				user-select: none

	.editor-control-input-coords-drag.change-process

		.control-coords

			.control-point-input

				label

					.label.active
						color: #20a8d8

	.editor-control-input-number-drag.dark-mini

		.control-number

			.number-input
				width: 60px
				height: 24px
				background-color: rgba(255, 255, 255, 0.05)
				border: 1px solid rgba(255, 255, 255, 0.09)
				border-radius: 0.1rem

				&:first-child
					border-top-right-radius: 0
					border-bottom-right-radius: 0
					border-top-left-radius: 0.1rem
					border-bottom-left-radius: 0.1rem
					margin-left: 0

				label

					.label
						width: 20px
						padding: 0
						border-right: 1px solid rgba(255, 255, 255, 0.05)

					input
						padding: 0 3px
						width: 60px
						font-size: 0.765625rem
						height: auto
						border: none
						border-radius: 2px
						background: none

						&:focus
							outline: none
							box-shadow: none

						&:hover
							outline: none
							box-shadow: none

			.control-point-drag
				width: 20px
				height: 20px

				&.active
					color: #20a8d8
					border-color: #20a8d8

	.editor-control-input-number-drag.dark-medium

		.control-number

			.number-input
				width: auto
				display: flex
				flex-direction: row
				flex-wrap: nowrap
				color: rgba(255, 255, 255, 0.87)

				label
					display: flex
					flex-direction: row
					flex-wrap: nowrap
					margin: 0
					padding: 0

				input
					margin: 0
					width: 60px
					height: 30px
					box-shadow: none
					padding: 0 7px
					font-size: 14px
					transition: none

					&:focus
						outline: none
						box-shadow: none
						background: #515b65
						border: 1px solid rgba(255, 255, 255, 0.3)

					&:hover
						outline: none
						box-shadow: none
						background: #515b65
						border: 1px solid rgba(255, 255, 255, 0.3)

			.control-point-drag
				width: 24px
				height: 24px
				margin-left: 10px

				&.active
					color: #20a8d8
					border-color: #20a8d8

	.editor-control-input-number-drag.dark-medium.disabled
		opacity: 0.4

		.control-number

			.number-input

				input

					&:focus
						outline: none
						box-shadow: none
						background: #515b65
						border: 1px solid #23282c

					&:hover
						outline: none
						box-shadow: none
						background: #515b65
						border: 1px solid #23282c

</style>
